import React from 'react';
import { PostsListContainer, PostItem, Seo } from '../components/ui';
import lang from '../assets/lang';

export const SinglePost = (props) => {

	const { postId } = props.match.params;
	const posts = lang.posts.filter((post) =>
		post.link === `/${postId}`
	);
	const post = { ...posts[0] };

	return (
		<PostsListContainer>
			<Seo
				pageTitle={post.title}
				metaDescription={post.title}
				metaKeywords={post.title}
			/>
			<PostItem
				title={post.title}
				text={post.text}
				image={post.image}
				author={post.author}
				authorImage={post.authorImage}
				postType={"singlePost"} />
		</PostsListContainer>
	);
};



// WEBPACK FOOTER //
// ./src/pages/SinglePost.js